// extracted by mini-css-extract-plugin
export default {"container":"my-orders-page_container__rI20B","content":"my-orders-page_content__bgKA1","header":"my-orders-page_header__vlQKG","orderList":"my-orders-page_orderList__nHUYb"};